import React, { createContext, useContext, useState, useCallback } from 'react';
import { theme, t } from '../theme';

const ConfirmContext = createContext();

export const useConfirm = () => useContext(ConfirmContext);

export const ConfirmProvider = ({ children }) => {
  const [state, setState] = useState(null);

  const confirm = useCallback((message, opts = {}) => {
    return new Promise((resolve) => {
      setState({ message, opts, resolve });
    });
  }, []);

  const handleClose = (result) => {
    state?.resolve(result);
    setState(null);
  };

  return (
    <ConfirmContext.Provider value={confirm}>
      {children}
      {state && (
        <div style={t.overlay} onClick={() => handleClose(false)}>
          <div style={{ ...t.modal, maxWidth: 380, padding: '28px 28px 20px' }} onClick={e => e.stopPropagation()}>
            <p style={{ fontSize: 15, color: theme.colors.text, margin: '0 0 20px', lineHeight: 1.5 }}>
              {state.message}
            </p>
            <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
              <button onClick={() => handleClose(false)} style={t.btnSecondary}>
                Cancelar
              </button>
              <button onClick={() => handleClose(true)} style={{
                ...t.btnPrimary,
                background: state.opts.danger ? theme.colors.danger : theme.colors.primary,
              }}>
                {state.opts.confirmText || 'Confirmar'}
              </button>
            </div>
          </div>
        </div>
      )}
    </ConfirmContext.Provider>
  );
};
